export const DEFAULT_TRAFFIC_SOURCE = 'home';
export const TRAFFIC_SOURCE_EXOCLICK = 'exoclick';
export const ADBLOCK_EXOCLICK = 'eck';
export const DIRECT_TRAFFIC_SOURCE = 'direct';
export const TRAFFIC_SOURCE_PROPELLER = 'propellerads';
export const ADBLOCK_PROPELLER = 'pls';
export const BOT_TRAFFIC_SOURCE = 'bot';
